import { thunkProgress } from 'redux-progress';
import hamsClient from 'modules/hams';
import { PLACE_ORDER } from 'modules/checkout/review/duck/actions/submit';
import type { Dispatch, GetState } from 'model/State';
import { selectHamsClientConfig } from 'modules/auth/selectors';
import selectCartPayload from 'modules/cart/duck/selectors/cart';
import type { CheckoutType } from 'modules/checkout/review/duck/actions/CheckoutTypes';

export default (cartId: string, checkoutType: CheckoutType) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    return dispatch(
      thunkProgress(
        PLACE_ORDER,
        hamsClient
          .post(
            `/1.0/public/order/cart/${cartId}/processPayOnTermsOrder`,
            { updatedTime: selectCartPayload(state).ifSuccess((cart) => cart.updated) },
            selectHamsClientConfig(state),
          )
          .then((r) => r),
        { checkoutType },
      ),
    );
  };
